import { render, staticRenderFns } from "./DetailsOfRefund.vue?vue&type=template&id=166dac69&"
import script from "./DetailsOfRefund.vue?vue&type=script&lang=js&"
export * from "./DetailsOfRefund.vue?vue&type=script&lang=js&"
import style0 from "./DetailsOfRefund.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports